import React from "react";
import Button from "carbon-react/lib/components/button";

const SearchButton = (props) => {
  return (
    <Button
      className="search-btn"
      iconType="search"
      iconPosition="before"
      buttonType="primary"
      {...props}
    >
      Search
    </Button>
  );
};

export default SearchButton;
